import React, { useState, useRef } from "react";

function AddVenue() {
  const fileInputRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [venue, setVenue] = useState({
    name: "",
    city: "",
    location: { address: "", lat: "", lng: "" },
    description: "",
    pricing: "",
    image: null,
    sports: "",
    amenities: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("name", venue.name);
    formData.append("city", venue.city);
    formData.append("location[address]", venue.location.address);
    formData.append("location[lat]", venue.location.lat);
    formData.append("location[lng]", venue.location.lng);
    formData.append("pricing", venue.pricing);
    formData.append("description", venue.description);
    formData.append("image", venue.image);
    formData.append("sports", venue.sports);
    formData.append("amenities", venue.amenities);

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        alert("You must be logged in as admin!");
        setIsSubmitting(false);
        return;
      }

      const res = await fetch("https://api.getfitindia.in/api/venues", {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      if (res.ok) {
        alert("Venue Added Successfully!");
        setVenue({
          name: "",
          city: "",
          location: { address: "", lat: "", lng: "" },
          description: "",
          pricing: "",
          image: null,
          sports: "",
          amenities: "",
        });
        if (fileInputRef.current) fileInputRef.current.value = "";
      } else {
        const errorData = await res.json();
        alert(`Failed to add venue: ${errorData.message}`);
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong!");
    }

    setIsSubmitting(false);
  };

  return (
    <>
      {/* ADMIN HEADER */}
      <div className="bg-[#0f2250] text-white sticky top-0 z-20">
        <div className="max-w-6xl px-4 py-4">
          <h1 className="text-lg font-semibold ms-12 sm:ms-0 mt-1">
           Add New Venue
          </h1>
        </div>
      </div>

      {/* FORM AREA */}
      <div className="flex justify-center px-4 sm:px-6 md:px-10 py-10 bg-[#f7f8fb] min-h-screen">

        <form
          onSubmit={handleSubmit}
          className="w-full max-w-2xl bg-white shadow-[0_0_6px_rgba(0,0,0,0.2)] rounded-2xl p-6 sm:p-8"
        >
        

          <div className="space-y-4">

            {/* Venue Name */}
            <div>
              <label className="text-sm text-gray-600 block mb-1 capitalize">
                Venue Name
              </label>
              <input
                type="text"
                placeholder="Enter venue name"
                className="w-full bg-[#f3f4f6] border border-gray-300 
                           rounded-md py-2 px-3 focus:ring-2 
                           focus:ring-[#0d2149] outline-none text-sm"
                value={venue.name}
                onChange={(e) => setVenue({ ...venue, name: e.target.value })}
              />
            </div>

            {/* City */}
            <div>
              <label className="text-sm text-gray-600 block mb-1 capitalize">City</label>
              <input
                type="text"
                placeholder="Enter city"
                className="w-full bg-[#f3f4f6] border border-gray-300 rounded-md 
                           py-2 px-3 focus:ring-2 focus:ring-[#0d2149] text-sm"
                value={venue.city}
                onChange={(e) => setVenue({ ...venue, city: e.target.value })}
              />
            </div>

            {/* Address */}
            <div>
              <label className="text-sm text-gray-600 block mb-1 ">Address</label>
              <textarea
                rows={3}
                placeholder="Full address"
                className="w-full bg-[#f3f4f6] border border-gray-300 rounded-md 
                           py-2 px-3 resize-none focus:ring-2 
                           focus:ring-[#0d2149] text-sm"
                value={venue.location.address}
                onChange={(e) =>
                  setVenue({
                    ...venue,
                    location: { ...venue.location, address: e.target.value },
                  })
                }
              />
            </div>

            {/* LAT / LNG */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="text-sm text-gray-600 block mb-1">
                  Latitude
                </label>
                <input
                  type="number"
                  placeholder="Latitude"
                  className="w-full bg-[#f3f4f6] border border-gray-300 rounded-md 
                             py-2 px-3 focus:ring-2 focus:ring-[#0d2149] text-sm"
                  value={venue.location.lat}
                  onChange={(e) =>
                    setVenue({
                      ...venue,
                      location: { ...venue.location, lat: e.target.value },
                    })
                  }
                />
              </div>

              <div>
                <label className="text-sm text-gray-600 block mb-1">
                  Longitude
                </label>
                <input
                  type="number"
                  placeholder="Longitude"
                  className="w-full bg-[#f3f4f6] border border-gray-300 rounded-md 
                             py-2 px-3 focus:ring-2 focus:ring-[#0d2149] text-sm"
                  value={venue.location.lng}
                  onChange={(e) =>
                    setVenue({
                      ...venue,
                      location: { ...venue.location, lng: e.target.value },
                    })
                  }
                />
              </div>
            </div>

            {/* Description */}
            <div>
              <label className="text-sm text-gray-600 block mb-1">
                Description
              </label>
              <textarea
                rows={3}
                placeholder="Write venue description"
                className="w-full bg-[#f3f4f6] border border-gray-300 rounded-md 
                           py-2 px-3 resize-none focus:ring-2 
                           focus:ring-[#0d2149] text-sm"
                value={venue.description}
                onChange={(e) => setVenue({ ...venue, description: e.target.value })}
              />
            </div>

            {/* Pricing */}
            {/* <div>
              <label className="text-sm text-gray-600 block mb-1">Pricing</label>
              <input
                type="text"
                placeholder="Price details"
                className="w-full bg-[#f3f4f6] border border-gray-300 rounded-md 
                           py-2 px-3 focus:ring-2 focus:ring-[#0d2149] text-sm"
                value={venue.pricing}
                onChange={(e) => setVenue({ ...venue, pricing: e.target.value })}
              />
            </div> */}

            {/* Sports */}
            <div>
              <label className="text-sm text-gray-600 block mb-1 capitalize">Sports</label>
              <input
                type="text"
                placeholder="e.g. Football, Badminton"
                className="w-full bg-[#f3f4f6] border border-gray-300 rounded-md 
                           py-2 px-3 focus:ring-2 focus:ring-[#0d2149] text-sm"
                value={venue.sports}
                onChange={(e) => setVenue({ ...venue, sports: e.target.value })}
              />
            </div>

            {/* Amenities */}
            <div>
              <label className="text-sm text-gray-600 block mb-1 capitalize">Amenities</label>
              <input
                type="text"
                placeholder="e.g. Water, Parking, Washroom"
                className="w-full bg-[#f3f4f6] border border-gray-300 rounded-md 
                           py-2 px-3 focus:ring-2 focus:ring-[#0d2149] text-sm"
                value={venue.amenities}
                onChange={(e) =>
                  setVenue({ ...venue, amenities: e.target.value })
                }
              />
            </div>

            {/* Upload Image */}
            <div>
              <label className="text-sm text-gray-600 block mb-1">
                Upload Image
              </label>
              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                className="w-full bg-[#f3f4f6] border border-gray-300 rounded-md 
                           py-[6px] px-3 text-sm focus:ring-2 
                           focus:ring-[#0d2149]"
                onChange={(e) =>
                  setVenue({ ...venue, image: e.target.files[0] })
                }
              />
            </div>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={isSubmitting}
            className={`mt-6 w-full py-2 rounded-md text-sm font-semibold transition
              ${
                isSubmitting
                  ? "bg-gray-400 cursor-not-allowed text-white"
                  : "bg-[#043f6e] text-white hover:bg-[#075aae]"
              }`}
          >
            {isSubmitting ? "Saving..." : "Add Venue"}
          </button>
        </form>
      </div>
    </>
  );
}

export default AddVenue;
